"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.splitSections = exports.joinSections = exports.hydrate = exports.isRichContent = exports.isBlankContent = exports.removeImages = exports.extractQuickLinks = exports.concatenate = exports.html = void 0;
exports.html = __importStar(require("./html"));
__exportStar(require("./interfaces"), exports);
// Strip observability; avoid relying on MobX in this low-level non-UI library
// by using some duck typing.
var demobx = function (thing) {
    return !Array.isArray(thing) && thing && typeof thing.peek === 'function'
        ? thing.peek()
        : thing;
};
/**
 * Join several pieces of rich content (with no added space between them).
 */
function concatenate() {
    var value = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        value[_i] = arguments[_i];
    }
    return value.reduce(function (acc, curr) {
        curr = demobx(curr);
        if (acc.length === 0) {
            return curr;
        }
        else if (!curr) {
            return acc;
        }
        return acc.concat(curr);
    });
}
exports.concatenate = concatenate;
/**
 * Scan rich content for `placeholder` and `calltoaction` embeds;
 * return all portal quick-link codes referenced by any
 *
 * This is necessary to provide hints to API about which personalizations
 * it needs to provide to the SendGrid API, which does the actual
 * interpolation of the recipient-specific quick links into the mail bodies.
 *
 * @return an Array of quick-link IDs (with no `portal_quick_link:` prefix)
 * @see Go (in lp/src/components/session/Go.ts)
 */
var extractQuickLinks = function (value) {
    return Array.from(new Set(value
        .map(function (op) {
        var embed = op.insert.calltoaction || op.insert.placeholder;
        if (embed) {
            var field = embed.field, id = embed.id;
            if (field && field.startsWith('portal_quick_link:')) {
                return field.slice(18);
            }
            else if (id) {
                return id;
            }
        }
    })
        .filter(function (ql) { return !!ql; })));
};
exports.extractQuickLinks = extractQuickLinks;
/**
 * Strip all images from the value. Use this to post-process editor contents
 * in contexts where images aren't allowed.
 *
 * @return a copy of value with all images removed
 */
var removeImages = function (value) {
    return value && value.filter(function (op) { var _a; return !((_a = op === null || op === void 0 ? void 0 : op.insert) === null || _a === void 0 ? void 0 : _a.image); });
};
exports.removeImages = removeImages;
/**
 * Test whether the content is null/undefined or consists of nothing but whitespace.
 */
function isBlankContent(value) {
    value = demobx(value);
    return (!value ||
        value.every(function (op) {
            return op.insert && typeof op.insert === 'string' && op.insert.trim() === '';
        }));
}
exports.isBlankContent = isBlankContent;
/**
 * Type guard for rich content. Does not exhaustively validate the content;
 * only validates the shape (array of object) and looks for at least one
 * object with an `insert` key.
 */
function isRichContent(value) {
    value = demobx(value);
    return value && Array.isArray(value) && value.some(function (o) { return o && o.insert; });
}
exports.isRichContent = isRichContent;
/**
 * Replace S3 content placeholders with freshly signed S3 URLs (which will expire after awhile)
 * taken from the `parts` parameter. Ignore any content URLs that do specify the `cid:`
 * protocol (e.g. `data:`, `im-temp:` or `https:`).
 *
 * This is necessary when preparing rich content for presentation on screen.
 *
 * If value is falsy, it is returned as-is, so this function is safe to call with null/undefined
 * rich content.
 *
 * TODO: support tempfiles (and not just attachments)
 */
function hydrate(value, _a) {
    var _b = _a === void 0 ? {} : _a, parts = _b.parts;
    // be helpful to IT authors since our ITs have terribly maintained network fixtures
    if (typeof value === 'object' && value && !(value === null || value === void 0 ? void 0 : value.map)) {
        throw new Error("richContent.hydrateSync: expected RichContent Array of Object (or falsey); got ".concat(typeof value));
    }
    return value === null || value === void 0 ? void 0 : value.map(function (op) {
        if (typeof op.insert !== 'object') {
            return op;
        }
        var image = op.insert.image;
        if (!parts || !(image === null || image === void 0 ? void 0 : image.startsWith('cid:'))) {
            return op;
        }
        var contentId = image.slice(4);
        var part = parts.find(function (p) { return p.contentId === contentId; });
        if (part) {
            image = part.url;
        }
        return __assign(__assign({}, op), { insert: { image: image } });
    });
}
exports.hydrate = hydrate;
/**
 * Join several pieces of rich content, adding a 0-width horizontal rule between each piece.
 * (The rule occupies one line of height, but is otherwise invisible.)
 *
 * The benefit of joining sections is that you can reliably split them later, no matter how
 * much editing the user has done.
 */
function joinSections() {
    var value = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        value[_i] = arguments[_i];
    }
    return value.reduce(function (acc, curr, i) {
        curr = demobx(curr);
        if (acc.length === 0) {
            return curr;
        }
        if (!(curr === null || curr === void 0 ? void 0 : curr.length)) {
            return acc;
        }
        else if (i) {
            return acc.concat([{ insert: { rule: { type: 'break-section', width: '0' } } }], curr);
        }
        else {
            return acc.concat(curr);
        }
    });
}
exports.joinSections = joinSections;
/**
 * Split a piece rich content into distinct sections as identified by rules with `type: 'break-section'`.
 */
function splitSections(value) {
    var sections = [];
    var curr = [];
    if (!value) {
        return sections;
    }
    value.forEach(function (op) {
        if (op.insert.rule && op.insert.rule.type === 'break-section') {
            sections.push(curr);
            curr = [];
        }
        else {
            curr.push(op);
        }
    });
    if (curr.length > 0) {
        sections.push(curr);
    }
    return sections;
}
exports.splitSections = splitSections;
